import { useContext } from 'react';
import { AuthContext } from './AuthContextInstance';
import type { AuthContextType } from './AuthContextTypes';

/**
 * Custom hook to access the Auth context.
 * Must be used within an AuthContextProvider.
 */
export function useAuthContext(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthContextProvider');
  }
  return context;
}

/**
 * Alias for useAuthContext (legacy compatibility).
 */
export function useAuth0(): AuthContextType {
  return useAuthContext();
}
